import { createTypedSxStyles, capitalDesignTokens } from '@opengov/capital-mui-theme';
import { paginationSelectSx } from '../../../StoryList/StoryListContent/StoryListTablePagination.styles';

const muiV37Gray50 = '#F8F8F8';
const muiV37BlackOpacity12 = 'rgba(0, 0, 0, 0.12)';

export const styles = createTypedSxStyles({
  skeleton: {
    height: 'calc(100vh - 500px)'
  },
  tableContainer: {
    border: `1px solid ${muiV37BlackOpacity12}`,
    borderRadius: '4px'
  },
  table: {
    overflow: 'auto',
    backgroundColor: muiV37Gray50,
    borderRadius: '4px'
  },
  iconHeader: {
    width: '20px',
    padding: '0px',
    backgroundColor: muiV37Gray50
  },
  headerCell: {
    textAlign: 'left',
    padding: '12px 16px',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    fontFamily: capitalDesignTokens.foundations.typography.baseFont,
    backgroundColor: muiV37Gray50
  },
  checkboxHeaderCell: {
    padding: '12px 16px',
    backgroundColor: muiV37Gray50,
    width: '48px'
  },
  bodyCell: {
    textAlign: 'left',
    padding: '12px 16px',
    borderBottom: `1px solid ${capitalDesignTokens.foundations.colors.gray300}`
  },
  checkboxBodyCell: {
    textAlign: 'left',
    padding: '12px 16px',
    borderBottom: `1px solid ${capitalDesignTokens.foundations.colors.gray300}`,
    width: '48px'
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: capitalDesignTokens.foundations.colors.gray100
    }
  },
  tableRowDisabled: {
    cursor: 'default',
    opacity: 0.6
  },
  iconCell: {
    padding: '0px'
  },
  bold: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  italics: {
    fontStyle: 'italic'
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px'
  },
  icon: {
    width: '18px',
    height: '18px'
  },
  pagination: {
    borderTop: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    position: 'sticky',
    bottom: 0,
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
    zIndex: 1,
    ...paginationSelectSx,
  }
});
